import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import * as boardApi from '@/apis/boards';

export const QUERY_KEYS = {
  faq: (params) => ['board', 'faq', params],
  faqDetail: (id) => ['board', 'faq', 'detail', id],
  library: (params) => ['board', 'library', params],
  libraryDetail: (id) => ['board', 'library', 'detail', id],
};

// FAQ 목록 조회
export const useFaqPosts = (params) => useQuery({
  queryKey: QUERY_KEYS.faq(params),
  queryFn: () => boardApi.getFaqPosts(params),
});

// FAQ 상세 조회
export const useFaqDetail = (postId) => useQuery({
  queryKey: QUERY_KEYS.faqDetail(postId),
  queryFn: () => boardApi.getFaqDetail(postId),
  enabled: !!postId,
});

// FAQ 등록
export const useCreateFaqPost = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: boardApi.createFaqPost,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['board', 'faq'] });
    },
  });
};

// FAQ 수정
export const useUpdateFaqPost = (postId) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data) => boardApi.updateFaqPost(postId, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['board', 'faq'] });
      queryClient.invalidateQueries({ queryKey: QUERY_KEYS.faqDetail(postId) });
    },
  });
};

// FAQ 삭제
export const useDeleteFaqPost = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: boardApi.deleteFaqPost,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['board', 'faq'] });
    },
  });
};

// 자료실 목록 조회
export const useLibraryPosts = (params) => useQuery({
  queryKey: QUERY_KEYS.library(params),
  queryFn: () => boardApi.getLibraryPosts(params),
});

// 자료실 상세 조회
export const useLibraryDetail = (postId) => useQuery({
  queryKey: QUERY_KEYS.libraryDetail(postId),
  queryFn: () => boardApi.getLibraryDetail(postId),
  enabled: !!postId,
});

// 자료실 파일 다운로드
export const useDownloadLibraryFile = () => useMutation({
  mutationFn: boardApi.downloadLibraryFile,
});

// 자료실 등록
export const useCreateLibraryPost = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: boardApi.createLibraryPost,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['board', 'library'] });
    },
  });
};

// 자료실 수정
export const useUpdateLibraryPost = (postId) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data) => boardApi.updateLibraryPost(postId, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['board', 'library'] });
      queryClient.invalidateQueries({ queryKey: QUERY_KEYS.libraryDetail(postId) });
    },
  });
};

// 자료실 삭제
export const useDeleteLibraryPost = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: boardApi.deleteLibraryPost,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['board', 'library'] });
    },
  });
};
